document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".geo-popup").forEach(popup => {
    const closeBtn = popup.querySelector(".geo-popup__close");
    const overlay = popup.querySelector(".geo-popup__overlay");

    function closePopup() {
      popup.classList.remove("active");
      document.body.classList.remove("geo-popup-open");
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    if (overlay) {
      overlay.addEventListener("click", closePopup);
    }
  });

  document.querySelectorAll(".geo-btn").forEach((geobtn) => {
    geobtn.addEventListener("click", () => {
      clearGeoSelect();
      geobtn.classList.toggle("active", true);

      const market = geobtn.dataset.market;
      handleMarketSelection(market);
    });
  });

  function clearGeoSelect() {
    document.querySelectorAll(".geo-btn").forEach((btn) => {
      btn.classList.toggle("active", false);
    });
  }

  function handleMarketSelection(market) {
    switch (market) {
      case "US":
        selectUsMarket();
        break;
      case "EU":
        selectEuropeMarket();
        break;
      case "DK":
        selectDenmarkMarket();
        break;
      case "ROW":
        selectRowMarket();
        break;
      default:
        console.warn("Unknown market:", market);
    }
  }

  function selectUsMarket() {
    const uslink = document.querySelector(
      '.geo-popup__list li.disclosure__item[data-market="US"] a',
    );
    if (uslink) uslink.click();
  }

  function selectDenmarkMarket() {
    const dklink = document.querySelector(
      '.geo-popup__list li.disclosure__item[data-market="DK"] a',
    );
    if (dklink) dklink.click();
  }

  function selectEuropeMarket() {
    const geoList = document.querySelector(".geo-popup__list");
    geoList.classList.toggle("active", true);

    // apply Europe filter
    document.querySelectorAll(".disclosure__item").forEach((item) => {
      if (item.dataset.market === "EU") item.style.display = "block";
      else item.style.display = "none";
    });
  }

  function selectRowMarket() {
    const geoList = document.querySelector(".geo-popup__list");
    geoList.classList.toggle("active", true);

    // apply ROW filter
    document.querySelectorAll(".disclosure__item").forEach((item) => {
      if (item.dataset.market === "ROW") item.style.display = "block";
      else item.style.display = "none";
    });
  }
});
